module.exports = __webpack_public_path__ + "img/5.08386a51.jpg";